import React from 'react';

import { LabelValue, LabelValueTypeConfig, withLabelTokenParsing } from './Content.jsx';
import Token from '../utility/Token.jsx';
import Utilities from '../utility/Utilities.jsx';

function _ItemMeta(props) {
    const hasValue = !Utilities.isHTMLContentEmpty(props.content);
    return <LabelValue {...props} renderPlaceholder={!hasValue} value={hasValue ? props.content : undefined} />;
}
const ItemMeta = withLabelTokenParsing(_ItemMeta, Token.TypeParsing.inventory);
const TypeConfig = {
    panel: {
        block: () => LabelValueTypeConfig.panel.block(1),
        description: LabelValueTypeConfig.panel.description,
        label: LabelValueTypeConfig.panel.label,
        style: LabelValueTypeConfig.panel.style,
        value: LabelValueTypeConfig.panel.value
    }
};

export {
    ItemMeta as Component,
    TypeConfig
}